import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import ViewEmployee from "../view";
import ViewEmployeeSetting from "./view";
import EditEmployeeSetting from "./edit";
import { MODULE_EMPLOYEES } from "variables/constants";

const employeeSettingRoutes = [
	generateCRUDRoutes({
		mainTitle: "Employee Settings",
		basePath: "employees/:employeeId/settings",
		mainComponent: <ViewEmployee />,
	    layout: "/console",	   
	    subTitle:"Employee Setting",
	    viewComponent: <ViewEmployeeSetting />,
	    createComponent: <EditEmployeeSetting />,
	    editComponent: <EditEmployeeSetting />,
		level:4,
		moduleId: MODULE_EMPLOYEES,   
	})
]

export default employeeSettingRoutes;